import { App } from 'vue';
import Bugsnag from '@bugsnag/js';

export default (app: App): void => {
  const plugin = Bugsnag.getPlugin('vue');

  if (plugin) {
    app.use(plugin);
  }
};
